const { differenceInDays, format } = require("date-fns")

module.exports = {
  groupConsecutiveDates: (dates) => {
    const groupedDates = dates.sort().reduce(
      (acc, date) => {
        const group = acc[acc.length - 1]
        if (
          differenceInDays(
            new Date(date),
            new Date(group[group.length - 1] || date)
          ) > 1
        ) {
          acc.push([date])
        } else {
          group.push(date)
        }
        return acc
      },
      [[]]
    )
    return groupedDates
  },
  formatDate: (dateString) => {
    return format(new Date(dateString), "yyyy-MM-dd, eeee")
  },
}
